var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('Navbar',{staticClass:"d-print-none",on:{"action:redirect":_vm.redirect}}),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"fill-height"},[_c('v-col',[_c('transition',{attrs:{"name":"fade"}},[_c('keep-alive',{attrs:{"include":[
                    'Home',
                    'BudgetVariance',
                    'Prickles',
                    'Prickles2',
                    'Prickles3',
                    'XeroRecon',
                    'Mfc' ]}},[_c('router-view')],1)],1)],1)],1)],1),_c('Toasts',{attrs:{"text":_vm.message,"color":"success"}}),_c('Toasts',{attrs:{"text":_vm.saved,"color":"success","timeout":-1}}),_c('Toasts',{attrs:{"text":_vm.error,"color":"error","timeout":-1}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }